var _path, _path2, _path3, _path4, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgHomePortfolio(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 64,
    height: 64,
    viewBox: "0 0 64 64",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M54 18H10C8.89543 18 8 18.8954 8 20V52C8 53.1046 8.89543 54 10 54H54C55.1046 54 56 53.1046 56 52V20C56 18.8954 55.1046 18 54 18Z",
    stroke: "url(#paint0_linear_1801_34553)",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M42 18V14C42 12.9391 41.5786 11.9217 40.8284 11.1716C40.0783 10.4214 39.0609 10 38 10H26C24.9391 10 23.9217 10.4214 23.1716 11.1716C22.4214 11.9217 22 12.9391 22 14V18",
    stroke: "url(#paint1_linear_1801_34553)",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M56 31.5752C48.7057 35.7938 40.4263 38.0102 32 38.0002C23.5721 38.0221 15.2897 35.8049 8 31.5752",
    stroke: "url(#paint2_linear_1801_34553)",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M29 30H35",
    stroke: "url(#paint3_linear_1801_34553)",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_1801_34553",
    x1: 13.1042,
    y1: 44.6666,
    x2: 42.5659,
    y2: 28.3485,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#047CFD"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#31B8F7"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_1801_34553",
    x1: 24.1268,
    y1: 15.9259,
    x2: 31.8446,
    y2: 7.91083,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#047CFD"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#31B8F7"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint2_linear_1801_34553",
    x1: 13.1042,
    y1: 36.3346,
    x2: 16.7258,
    y2: 25.0956,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#047CFD"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#31B8F7"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint3_linear_1801_34553",
    x1: 29.638,
    y1: 30.7407,
    x2: 30.3053,
    y2: 29.0776,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#047CFD"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#31B8F7"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgHomePortfolio);
export default __webpack_public_path__ + "static/media/home-portfolio.cf49aa6d6d1105426dcc15707d77337f.svg";
export { ForwardRef as ReactComponent };